import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { isCallState, isOutputState } from "./types.js";
import { ProductSearchQueriesSection } from "../ProductSearchQueriesSection.js";
function buildDisplayQuery(product, brand) {
  const trimmed = (product || "").trim();
  if (!brand || trimmed.toLowerCase().includes(brand.toLowerCase())) {
    return trimmed;
  }
  return `${brand} ${trimmed}`;
}
function SearchProductsPart({
  part,
  allParts,
  onProductClick,
  isStreaming
}) {
  var _a, _b;
  const searchQueryResults = allParts.filter((p) => p.type === "data-search-query-result").map((p) => p.data);
  const input = part.input;
  const searchAngles = input == null ? void 0 : input.searchAngles;
  const hasAngles = Array.isArray(searchAngles) && searchAngles.length > 0;
  if (hasAngles) {
    const previewSearchQueries = searchAngles.map((a) => buildDisplayQuery(a.product, a.brand));
    const isSearchActive = isCallState(part.state);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        ProductSearchQueriesSection,
        {
          previewSearchQueries,
          previewQueryProducts: searchQueryResults,
          isStreaming: isSearchActive,
          hasContent: !isSearchActive
        }
      ),
      isOutputState(part.state) && ((_a = part.output) == null ? void 0 : _a.noRelevantProducts) && /* @__PURE__ */ jsx("div", { className: "concierge-no-results", children: "No relevant products found for this search." })
    ] });
  }
  if (isCallState(part.state)) {
    const query = (input == null ? void 0 : input.query) || "products";
    return /* @__PURE__ */ jsx("div", { className: "concierge-search-loading", children: /* @__PURE__ */ jsxs("div", { className: "concierge-search-loading-text", children: [
      "Searching for ",
      query,
      "..."
    ] }) });
  }
  if (isOutputState(part.state) && ((_b = part.output) == null ? void 0 : _b.noRelevantProducts)) {
    return /* @__PURE__ */ jsx("div", { className: "concierge-no-results", children: "No relevant products found for this search." });
  }
  return null;
}
export {
  SearchProductsPart
};
//# sourceMappingURL=SearchProductsPart.js.map
